import { throwError, of } from 'rxjs';
import { retryWhen, delay, concatMap } from 'rxjs/operators';
export var retryTime = function (delayTime, scheduler) {
    return retryWhen(function (errors) { return typeof delayTime === 'number'
        ? errors.pipe(delay(delayTime, scheduler))
        : errors.pipe(concatMap(function (e, index) { return delayTime.length === index
            ? throwError(e)
            : of(e).pipe(delay(delayTime[index], scheduler)); })); });
};
//# sourceMappingURL=retryTime.js.map